import React from "react";
import { Button, ButtonGroup, Spinner } from "@livingdesign/react";
import ModalLD3 from "../../../../../../common/Modal/ModalLD3";
import QA from "../../../../../../../../consts/QA";
export const QA_ID_PREFIX = `${QA.PAGES.HOME}-DivisionListDownloadModal`;

function DivisionListDownloadModal({
  isOpen,
  onClose,
  title,
  subTitle,
  id,
}) {
  return (
    <>
          <ModalLD3
              isOpen={isOpen}
              onClose={onClose}
              title={title}
              actions={
                  <div data-testid={`${QA_ID_PREFIX}-actions`}>
                      <ButtonGroup data-testid={`${QA_ID_PREFIX}-button-group`}>
                          <Button
                              variant="primary"
                              size="medium"
                              onClick={onClose}
                              data-testid={`${QA_ID_PREFIX}-edit-button`}
                          >
                              Continue
                          </Button>
                      </ButtonGroup>
                  </div>
              }
        size={"medium"}
        id={id}
        data-testid={`${QA_ID_PREFIX}-modal`}
      >{subTitle}</ModalLD3>
    </>
  );
}

export default DivisionListDownloadModal;